(function() {
    'use strict';

    angular
        .module('app')
        .controller('visualpageController', visualpageController);

    function visualpageController(viewModel, menuService, commonService, apiUrl, sysCode,
        bulletinService, headerService) {
        var vm = this;
        vm.showSelected = showSelected;
        vm.download = download;
        vm.menuAlterClick = menuAlterClick;
        init();

        function init() {
            vm.data = viewModel.data;
            vm.view = viewInit();
            vm.localValue = localValueInit();
            treeInit();
            menuAlterInit();
            $(document).trigger('visualPageInited', {});
        }

        function viewInit() {
            var result = {};

            return result;
        }

        function localValueInit() {
            var result = {
                menuAlterNodes: [],
                selectedMenuText: '',
                selectedMenuIndex: 0,
            };
            return result;
        }

        function showSelected(node) {
            if (node.url) {
                menuService.redirectUrl(node);
            }
        }

        function treeInit() {
            vm.treeOptions = {
                nodeChildren: "children",
                dirSelectable: false
            };
        }

        function menuAlterInit() {
            vm.localValue.menuAlterNodes = [];
            _.forEach(vm.data.treeView, function(treeNode) {
                treeNodeView(treeNode, '');
            });

            //以visualPage的ID來判斷選擇到的MenuLangName
            var menuNo = getMenuQueryString();
            //console.log("menuNo:", menuNo);
            var menuSelectedIndex = 0;
            for (var i = 0; i <= vm.localValue.menuAlterNodes.length - 1; i++) {
                if (vm.localValue.menuAlterNodes[i].menuSerilNo === menuNo) {
                    menuSelectedIndex = i;
                }
            }
            menuAlterClick(menuSelectedIndex, true);
            return;
            //======
            function treeNodeView(treeNode, preSymbol) {
                var _preSymbol = '　' + (preSymbol || '');
                treeNode.isEmptyUrl = false;
                treeNode.url = treeNode.url || '';
                if (treeNode.url.length < 1) {
                    treeNode.isEmptyUrl = true;
                }
                treeNode.menuAlterText = _preSymbol + treeNode.menuLangName;
                //======
                vm.localValue.menuAlterNodes.push(treeNode);
                if (!treeNode.children) {
                    treeNode.children = [];
                }
                _.forEach(treeNode.children, function(treeNodeChild) {
                    treeNodeView(treeNodeChild, _preSymbol);
                });
            }
        }

        function menuAlterClick(index, isInit) {
            var targetNode = vm.localValue.menuAlterNodes[index];
            //====
            var isError = (!targetNode);
            //====
            if (isError) {
                vm.localValue.selectedMenuText = "";
                vm.localValue.selectedMenuIndex = 0;
            } else if (targetNode.isEmptyUrl) {
                return;
            } else {
                vm.localValue.selectedMenuText = targetNode.menuLangName;
                vm.localValue.selectedMenuIndex = index;
            }
            if (!isInit) {
                menuService.redirectUrl(targetNode);
            }
            return;
        }

        function download(url, fileName) {
            console.log('url:', url);
            console.log('fileName:', fileName);
            if (url && fileName) {
                var params = {
                    menuSerilNo: getMenuQueryString(),
                    MenuClickAttachmentId: url,
                };
                commonService.setParams(params);
                headerService.saveMenuClickingAttachment(params);
                //先確認是否是把浮水印拿掉就不能下載(在PC上)
                // if (commonService.getFileType(url) !== 'pdf') {

                // } else {
                //     var param = {
                //         wholeUrl: url,
                //         fileName: fileName,
                //     };
                //     bulletinService.donwloadStampForUrl(param);
                // }

                //因應ios無法打開可視化中的PDF，ios另行處理
                window.open(url,'_self');
                // if (DEVICE_TYPE !== null && DEVICE_TYPE.toLowerCase() === 'ios') {
                //     window.open(url,'_self');
                // } else {
                //     window.open(url);
                // }
            }
        }
    }
})();